"use strict";

function initAuthors(id) {
  console.log(id);
  $.ajax({
    method: 'GET',
    url: '/api/v1/lawyers/' + id,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    success: function success(data) {
      renderInitAuthors(data);
    },
    error: function error(err) {
      console.log(err);
    }
  });
}

function renderInitAuthors(data) {
  var wrapper = $('#authors_panel'),
      name = data.first_name + ' ' + data.last_name,
      id = data.id,
      nb = data.nb_private_articles;
  var div = '<div class="results-panel flex items-center js-result-panel">' + '<div class="flex-row">' + '<p>' + name + '</p><p class="mlx">(' + nb + ')</p>' + '</div>' + '<div class="close js-result-close authors" data-id="' + id + '">' + '<img src="' + close_img + '" title="Delete" />' + '</div>' + '</div>';
  wrapper.append(div);
  $('.js-result-panel').find('.js-result-close').deleteSearchAuthorsItem(authorsArray);
}

function ajaxCallauthors(url) {
  $.ajax({
    method: 'GET',
    url: url,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    success: function success(data) {
      showResultsAuthors();
      showAuthors(data.authors);
      addInputValue(data.authors);
    },
    error: function error(err) {
      console.log(err);
    }
  });
}

function showResultsAuthors() {
  var results = $('.js-results-authors');
  results.addClass('is-open');
  results.empty();
  $window.on('click', function () {
    results.removeClass('is-open');
  });
  results.click(function (event) {
    event.stopPropagation();
  });
}

function showAuthors(authors) {
  var results = $('.js-results-authors');
  var res = '';

  for (var i = 0; i < authors.length; i++) {
    var title = authors[i].author_obj.first_name + ' ' + authors[i].author_obj.last_name,
        id = authors[i].author_obj.id,
        nb = authors[i].author_obj.nb_private_articles;

    if (i > 0) {
      var prev = authors[i - 1];
      var prevId = prev.author_obj.id;
    } else {
      var prevId = null;
    }

    if (prevId == null && id !== prevId) {
      res = res + '<li class="js-author-value" data-id="' + id + '" data-name="' + title + '" data-nb="' + nb + '">' + '<div>' + '<p>' + title + '</p>' + '</div>' + '</li>';
    }
  }

  results.append(res);
}

function addInputValue(authors) {
  var items = $('.js-results-authors').find('li');

  for (var i = 0; i < authors.length; i++) {
    var nb = authors[i].author_obj.nb_private_articles;
  }

  items.on('click', function () {
    $('#author_news').val('');
    var wrapper = $('#authors_panel');
    var div = '<div class="results-panel flex items-center js-result-panel">' + '<div class="flex-row">' + '<p>' + $(this).data('name') + '</p><p class="mlx">(' + $(this).data('nb') + ')</p>' + '</div>' + '<div class="close js-result-close authors" data-id="' + $(this).data('id') + '">' + '<img src="' + close_img + '" title="Delete" />' + '</div>' + '</div>';
    wrapper.append(div);
    addParametersToArray(authorsArray, $(this).data('id'), 'authors');
    vueArticles.getArticles();
    $('.js-result-panel').find('.js-result-close').deleteSearchAuthorsItem(authorsArray);
    $('.js-results-authors').removeClass('is-open');
  });
}

function inputAuthor() {
  var textInput = document.getElementById('author_news');
  var timeout = null;

  textInput.onkeyup = function (e) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      if (textInput.value.length > 0) {
        ajaxCallauthors('/api/v1/blog-author-autocomplete?value=' + textInput.value);
      } else {
        $('.js-results-blog').removeClass('is-open');
        setTimeout(function () {
          $('.js-results-blog').empty();
        }, 500);
      }
    }, 500);
  };
}

(function ($) {
  $.fn.deleteSearchAuthorsItem = function (array) {
    var $that = $(this);
    $that.on('click', function (e) {
      e.preventDefault();
      removeParametersToArray(array, $(this).attr('data-id'), 'authors');
      vueArticles.getArticles();
      $(this).parent().remove();
    });
  };
})(jQuery);